import req from '../http';
import urls from '../../utils/config';

const marketUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_MARKETURL : urls['marketUrl'];
const loginSjUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_LOGINSJURL : urls['loginSjUrl'];
const url = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_LOGINSJURL : urls['url'];

export const getAppletQRCode = params => req('post', '/third/wechat/getAppletQRCode', params, {
  baseURL: loginSjUrl,
}); // 获取小程序太阳码

export const saveShareParam = params => req('post', '/client/activity/share/saveShareParam', params, {
  baseURL: marketUrl,
}); // 分享二维码参数过长-保存

export const getRuleAllInvite = params => req('post', '/client/activity/invite/getRuleAllInvite', params, {
  baseURL: marketUrl,
}); // 查询邀请活动-活动节点

export const getShareParamById = params => req('post', '/client/activity/share/getShareParamById', params, {
  baseURL: marketUrl,
}); // 获取分享二维码过长参数

export const getInviteRecord = params => req('post', '/client/activity/invite/getInviteRecord', params, {
  baseURL: marketUrl,
}); // 获取邀请记录

export const accept = params => req('post', '/client/activity/invite/accept', params, {
  baseURL: marketUrl,
}); // 接受邀请-登陆后接受邀请

export const getAuditStatus = params => req('post', '/member/person/getAuditStatus', params); // 获取用户认证状态

export const getUserInfo = params => req('post', '/coupon/market/common/getUserInfo', params); // 获取用户个人信息--解析

export const getBroadCastList = params => req('post', '/client/activity/broadcast/getBroadCastList', params, {
  baseURL: marketUrl,
}); // 播报

// export const getJsSdkSignature = params => req('post', '/third/applet/getJsSdkSignature', params); // 获取JsSdk签名

export const getPoster = params => req('post', '/client/activity/info/getPoster', params, {
  baseURL: marketUrl,
}); // 生成海报


//查询活动账户信息
export const getAccountInfo = params => req('post', '/client/activity/account/getAccountInfo', params, {
  baseURL: marketUrl,
});


export const getActivityLink = params => req('post', '/client/activity/info/getActivityLink', params, {
  baseURL: marketUrl,
}); // 查询活动信息-活动分享的信息

//传递img
export const updateAccountInfo = params => req('post', '/client/activity/account/updateAccountInfo', params, {
  baseURL: marketUrl,
});

// 活动类型 1 拼团 2 概率活动 3 完单活动 4 签到 5 天降福袋 6 兑换 7 送如意 8 邀请认证 9 车主认证
export const getActivityInfo = params => req('post', '/client/activity/info/getActivityInfo', params, {
  baseURL: marketUrl,
});


//查询服务器时间
export const getDatetime = params => req('post', '/client/activity/fallLuckBag/getDatetime', params, {
  baseURL: marketUrl,
});

//查询有福袋时间列表
export const getFallLuckyBagList = params => req('post', '/client/activity/fallLuckBag/getFallLuckyBagList', params, {
  baseURL: marketUrl,
});

//开启福袋
export const openFallLuckyBag = params => req('post', '/client/activity/fallLuckBag/openFallLuckyBag', params, {
  baseURL: marketUrl,
});

//获取签到记录
export const getSignInRecord = params => req('post', '/client/activity/sign/getSignInRecord', params, {
  baseURL: marketUrl,
});

//签到
export const signIn = params => req('post', '/client/activity/sign/signIn', params, {
  baseURL: marketUrl,
});


//赠送如意
export const sendRuyi = params => req('post', '/client/activity/sendruyi/sendRuyi', params, {
  baseURL: marketUrl,
});

//赠送如意规则
export const queryRuleSendRuyi = params => req('post', '/client/activity/sendruyi/queryRuleSendRuyi', params, {
  baseURL: marketUrl,
});

//获取用户中奖明细
export const getRecordList = params => req('post', '/client/activity/record/getRecordList', params, {
  baseURL: marketUrl,
});

//获取用户中奖明细
export const getSignBlessing = params => req('post', '/client/activity/sign/getSignBlessing', params, {
  baseURL: marketUrl,
});


//查询兑换专区列表
export const queryRuleExchange = params => req('post', '/client/activity/exchange/queryRuleExchange', params, {
  baseURL: marketUrl,
});
//查询兑换专区--兑换
export const exchange = params => req('post', '/client/activity/exchange/exchange', params, {
  baseURL: marketUrl,
});


//播报
export const getBroadCastListFun = params => req('post', '/client/activity/broadcast/getAllBroadCastList', params, {
  baseURL: marketUrl,
});


//播报
export const querySendRuyiInfo = params => req('post', '/client/activity/sendruyi/querySendRuyiInfo', params, {
  baseURL: marketUrl,
});

//分享h5的签名
export const getJsSdkSignature = params => req('post', '/third/wechat/getJsSdkSignature', params ,{
  baseURL: url,
});
// 获取微信url
export const getWxMiniURLLink = params => req('post', '/carOrder/carOwner/getArbitrarilyLink',
    params, { baseURL: url });



